export default "__VITE_ASSET__BoIU1vBF__"